import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllReviews = (page , limit ) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_reviews_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/reviews`, {
            params: {
                page,
                limit,
            },
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_reviews_success',
            payload: {
                reviews: data.reviews,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_reviews_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};

export const getFillterReviews = (page , limit,titleAr,titleEn,date) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_reviews_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/reviews/filter`, {
            params: {
                page,
                limit,
                titleAr,
                titleEn,
                date
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_reviews_success',
            payload: {
                reviews: data.reviews,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_reviews_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getReview = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_review_request' });

        const { data } = await axios.get(`${BaseUrl}/reviews/${id}`);
      
        dispatch({ type: 'get_review_success' ,payload:data.review});

    } catch (error) {
        dispatch({
            type: "get_review_error",
            payload: error.response.data.message,
          });
    }
}